import { useEffect, useState } from 'react'
import classes from './ReadMore.module.scss'
import Link from 'next/link'
import newsApi from '../../../../api/news'
import { getFileFullPath, isLinkForVideo } from '../../../../utils/Helpers'

function ReadMore({
  currentPostSlug,
  categoryId,
  categoryName,
  orientation = 'vertical',
}) {
  const [newsItems, setNewsItems] = useState([])

  useEffect(() => {
    async function getNewsItems() {
      const results = await newsApi.getNewsByCategoryId(categoryId, 1, 4)
      const newsItemsData = results.data.data
        .filter((post) => post.slug !== currentPostSlug)
        .slice(0, 3)
      setNewsItems(newsItemsData)
    }
    getNewsItems()
  }, [])

  return newsItems.length ? (
    orientation === 'vertical' ? (
      <div className="w-full flex flex-col px-2">
        <p className="uppercase text-dnred">Pročitajte još</p>
        <div className="flex flex-col justify-between mt-3 px-4 border-l-4 border-dnred text-dnred font-bold leading-4">
          {newsItems.map((newsItem, id) => (
            <Link href={`/${categoryName}/-/${newsItem.slug}`} key={id}>
              <a className="mb-2 last:mb-0">
                <div
                  className={`${classes.newsItemContainer} relative h-24 w-full flex items-center`}
                >
                  <div className="w-3/12 h-full mr-3">
                    {isLinkForVideo(newsItem.featured_image) ? (
                      <video
                        autoPlay
                        muted
                        controls
                        src={getFileFullPath(newsItem.featured_image)}
                      >
                        Your browser does not support videos.
                      </video>
                    ) : (
                      <img
                        className="w-full h-full object-cover"
                        src={getFileFullPath(newsItem.featured_image)}
                        alt={newsItem.featured_legend}
                      />
                    )}
                  </div>
                  <h3
                    className="w-9/12"
                    style={{
                      fontSize: 18,
                      fontFamily: 'lato-bold',
                      lineHeight: 1.3,
                    }}
                  >{`${newsItem.name}`}</h3>
                </div>
              </a>
            </Link>
          ))}
        </div>
      </div>
    ) : (
      <div className="flex flex-col p-4 pt-1 mx-2 mt-6 bg-grayBackground">
        <p className="uppercase text-red-600">{categoryName}</p>
        <div className="flex pt-4 px-4 border-t-4 border-dnred font-bold leading-4">
          {newsItems.map((newsItem, id) => (
            <Link href={`/${categoryName}/-/${newsItem.slug}`} key={id}>
              <a className="w-4/12 mr-12 last:mr-0">
                <div
                  className={`${classes.newsItemContainerHorizontal} relative w-full flex flex-col`}
                >
                  <div className="w-full h-28">
                    {isLinkForVideo(newsItem.featured_image) ? (
                      <video
                        autoPlay
                        muted
                        controls
                        src={getFileFullPath(newsItem.featured_image)}
                      >
                        Your browser does not support videos.
                      </video>
                    ) : (
                      <img
                        className="w-full h-full object-cover"
                        src={getFileFullPath(newsItem.featured_image)}
                        alt={newsItem.featured_legend}
                      />
                    )}
                  </div>
                  <h3
                    className="mt-2"
                    style={{
                      fontSize: 14,
                    }}
                  >{`${newsItem.name}`}</h3>
                </div>
              </a>
            </Link>
          ))}
        </div>
      </div>
    )
  ) : null
}

export default ReadMore
